/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'StepByStepContainerBlock';
const CLS = 'stepByStepContainerBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/stepByStepContainerBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class StepByStepContainerBlock {
	constructor($el) {
		// $el is the widget node return by the loadStepByStepContainerBlock function
		this.$el = $el;
	}

	init() {
		this.setStepByStepContainerBlock();
	}

	setStepByStepContainerBlock() {
		// Add Some logic here
		const $wg = $(this.$el);
		let stepsBtns = $wg.find('.step-item');
		let steps = $wg.find('.stepByStepItemBlock');

		stepsBtns.on('click', function() {
			let $btn = $(this);
			let indx = $btn.index();
			stepsBtns.removeClass('is-active');
			$btn.addClass('is-active');

			steps.addClass('d-none');
			steps.eq(indx).removeClass('d-none');

			$(window).trigger('scroll');
		});

		steps.each(function(index, el) {
			let imgHolder = $(el).find('.stepByStepItemBlock-images');

			// first step and we have multiple steps
			if (index == 0 && steps.length > 1) {
				imgHolder.append(`<span class="fas fa-chevron-right next-step"></span>`);
			}
			// middle steps
			if (index > 0 && index < (steps.length - 1)) {
				imgHolder.append(`<span class="fas fa-chevron-right next-step"></span>`);
				imgHolder.append(`<span class="fas fa-chevron-left prev-step"></span>`);
			}
			// last step
			if (index == (steps.length -1) && steps.length > 1) {
				imgHolder.append(`<span class="fas fa-chevron-left prev-step"></span>`);
			}
		});

		$wg.on('click', '.prev-step, .next-step', function() {
			let currentIndex = steps.not('.d-none').first().index();
			let newIndex;

			steps.addClass('d-none');

			if ($(this).hasClass('prev-step')) {
				newIndex = currentIndex - 1;
			} else {
				newIndex = currentIndex + 1;
			}

			stepsBtns.eq(newIndex).trigger('click');
		});
	}

	// Add more functions like on above here
}
